import { render, staticRenderFns } from "./AboutFoncicen.vue?vue&type=template&id=18a6b0e8&scoped=true"
import script from "./AboutFoncicen.vue?vue&type=script&lang=js"
export * from "./AboutFoncicen.vue?vue&type=script&lang=js"
import style0 from "./AboutFoncicen.vue?vue&type=style&index=0&id=18a6b0e8&prod&scoped=true&lang=css"
import style1 from "./AboutFoncicen.vue?vue&type=style&index=1&id=18a6b0e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6b0e8",
  null
  
)

export default component.exports